<template>
  <div class="dialogInside">
    <!--合法使用需要证明 -->
    <el-dialog
      v-if="xianshi == '合法使用需要证明' ? innerVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="xianshi == '合法使用需要证明' ? innerVisible : false"
      center
      :show-close="false"
      custom-class="zhengjia1"
    >
      <el-form ref="form" :model="gmFjmes" :rules="rules">
        <el-form-item label-width="91px" label="单位名称:" prop="hfsyDwmc">
          <el-input
            v-model="gmFjmes.hfsyDwmc"
            placeholder="请输入单位名称"
            disabled
          />
        </el-form-item>
        <el-form-item label-width="91px" label="化学品:" prop="hfsyHxpmc">
          <el-input
            v-model="gmFjmes.hfsyHxpmc"
            disabled
            placeholder="请输入化学品"
          />
          <!-- <el-cascader
            v-model="gmFjmes.hfsyHxpmc"
            placeholder="请选择化学品"
            :disabled="type"
            :options="options"
            :props="{ expandTrigger: 'hover' }"
            @change="handleChange"
          ></el-cascader>-->
        </el-form-item>
        <el-form-item label-width="91px" label="涉及量:" prop="hfsySl">
          <el-input
            v-model="gmFjmes.hfsySl"
            placeholder="请输入涉及量"
            :disabled="type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="签订日期:" prop="hfsyQdrq">
          <el-date-picker
            v-model="gmFjmes.hfsyQdrq"
            type="date"
            placeholder="请输入签订日期"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: true,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ fileList.length }}/6） (500KB以内)
          </div>
          <el-upload
            :headers="token"
            class="avatar-uploader"
            :disabled="type"
            ref="upload"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>

          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="confirm('form', 'cancel')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type"
          @click="confirm('form', 'tj')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!-- 营业执照 -->
    <el-dialog
      v-if="xianshi == '营业执照' ? innerVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="xianshi == '营业执照' ? innerVisible : false"
      center
      :show-close="false"
      custom-class="zhengjia2"
    >
      <el-form ref="form" :model="gmFjmes" :rules="rules">
        <el-form-item label-width="91px" label="名称:" prop="yyzzMc">
          <el-input
            v-model="gmFjmes.yyzzMc"
            placeholder="请输入"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item
          label-width="135px"
          label="统一社会信用代码:"
          prop="yyzzTyshxydm"
        >
          <el-input
            v-model="gmFjmes.yyzzTyshxydm"
            placeholder="请输入"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="类型:" prop="yyzzLx">
          <!-- <el-input
            v-model="gmFjmes.yyzzLx"
            placeholder="请输入"
            :disabled="type"
          ></el-input> -->

          <el-select
            v-model="gmFjmes.yyzzLx"
            style="width: 340px"
            placeholder="请输入"
            :disabled="type"
          >
            <el-option
              v-for="item in dwlxList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label-width="91px" label="法定代表人:" prop="yyzzFr">
          <el-input
            v-model="gmFjmes.yyzzFr"
            placeholder="请输入"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="注册资本:" prop="yyzzZczbxg">
          <el-input
            v-model="gmFjmes.yyzzZczb"
            placeholder="请输入"
            :disabled="type"
          />
          <el-select
            v-model="gmFjmes.yyzzZczbdw"
            placeholder="单位"
            :disabled="type"
          >
            <el-option
              v-for="item in yzd_zjzj"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="gmFjmes.fzjg"
            :disabled="type"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="营业期限:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="gmFjmes.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="type"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="gmFjmes.yxqJs"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions1"
                :disabled="type"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="成立日期:" prop="yyzzClrq">
          <el-date-picker
            v-model="gmFjmes.yyzzClrq"
            type="date"
            placeholder="请选择日期"
            :disabled="type"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="经营范围:" prop="yyzzJyfw">
          <el-input
            v-model="gmFjmes.yyzzJyfw"
            type="textarea"
            :rows="3"
            resize="none"
            placeholder="请输入经营范围"
            :disabled="type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="gmFjmes.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="type"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: true,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="type"
            class="avatar-uploader"
            ref="upload"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="confirm('form', 'cancel')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type"
          @click="confirm('form', 'tj')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!--其他证件-->
    <el-dialog
      v-if="xianshi == '其他证件' ? innerVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="xianshi == '其他证件' ? innerVisible : false"
      center
      custom-class="zhengjia3"
      :show-close="false"
    >
      <el-form ref="form" :model="gmFjmes" :rules="rules">
        <el-form-item label-width="91px" label="证件名称:" prop="qtzjZsmc">
          <el-input
            v-model="gmFjmes.qtzjZsmc"
            placeholder="请输入"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="证件编号:" prop="qtzjZsbh">
          <el-input
            v-model="gmFjmes.qtzjZsbh"
            placeholder="请输入证件编号"
            :disabled="type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="gmFjmes.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="type"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="gmFjmes.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="type"
                :picker-options="pickerOptions1"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="gmFjmes.fzjg"
            :disabled="type"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="gmFjmes.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="type"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: true,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="type"
            class="avatar-uploader"
            ref="upload"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="confirm('form', 'cancel')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type"
          @click="confirm('form', 'tj')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!-- 购销合同 -->
    <el-dialog
      v-if="xianshi == '购销合同' ? innerVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="xianshi == '购销合同' ? innerVisible : false"
      center
      :show-close="false"
      custom-class="zhengjia4"
    >
      <el-form ref="form" :model="gmFjmes" :rules="rules">
        <el-form-item label-width="91px" label="化学品:" prop="gxhtHxp">
          <el-cascader
            ref="hxps"
            v-model="gmFjmes.gxhtHxp"
            placeholder="请选择化学品"
            :props="{ emitPath: false }"
            :disabled="type"
            :options="options"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="合同编号:" prop="gxhtHtbh">
          <el-input
            v-model="gmFjmes.gxhtHtbh"
            placeholder="请输入证件编号"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="甲方名称:" prop="gxhtJfm">
          <el-input
            v-model="gmFjmes.gxhtJfm"
            :disabled="type"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="乙方名称:" prop="gxhtYfm">
          <el-input
            v-model="gmFjmes.gxhtYfm"
            :disabled="type"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="签订日期:" prop="gxhtQdrq">
          <el-date-picker
            v-model="gmFjmes.gxhtQdrq"
            type="date"
            placeholder="请选择日期"
            :disabled="type"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: true,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            :headers="token"
            :disabled="type"
            class="avatar-uploader"
            ref="upload"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="confirm('form', 'cancel')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type"
          @click="confirm('form', 'tj')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!-- 其他组织的登记证书或者成立批准文件 -->
    <el-dialog
      v-if="
        xianshi == '其他组织的登记证书或者成立批准文件' ? innerVisible : false
      "
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="
        xianshi == '其他组织的登记证书或者成立批准文件' ? innerVisible : false
      "
      center
      custom-class="zhengjia3"
      :show-close="false"
    >
      <el-form ref="form" :model="gmFjmes" :rules="rules">
        <el-form-item label-width="91px" label="证件名称:" prop="qtzjZsmc">
          <el-input
            v-model="gmFjmes.qtzjZsmc"
            placeholder="请输入"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="证件编号:" prop="qtzjZsbh">
          <el-input
            v-model="gmFjmes.qtzjZsbh"
            placeholder="请输入证件编号"
            :disabled="type"
          />
        </el-form-item>

        <el-form-item label-width="91px" label="证件有效期:" required>
          <el-col :span="11.5">
            <el-form-item prop="yxqKs">
              <el-date-picker
                v-model="gmFjmes.yxqKs"
                type="date"
                placeholder="选择日期"
                :disabled="type"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="line"
            :span="1"
            style="margin: 0 5px; text-align: center; width: 20px"
          >
            <span>至</span>
          </el-col>
          <el-col :span="11.5">
            <el-form-item prop="yxqJs">
              <el-date-picker
                v-model="gmFjmes.yxqJs"
                type="date"
                placeholder="选择日期"
                :disabled="type"
                :picker-options="pickerOptions1"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="91px" label="发证机关:" prop="fzjg">
          <el-input
            v-model="gmFjmes.fzjg"
            :disabled="type"
            placeholder="请输入发证机关"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="发证日期:" prop="fzrq">
          <el-date-picker
            v-model="gmFjmes.fzrq"
            type="date"
            placeholder="请输入发证日期"
            :disabled="type"
            style="width: 174px"
          />
        </el-form-item>
        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: true,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            ref="upload"
            :headers="token"
            :disabled="type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="confirm('form', 'cancel')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type"
          @click="confirm('form', 'tj')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!-- 购买单位经办人身份证 -->
    <el-dialog
      v-if="xianshi == '购买单位经办人身份证' ? innerVisible : false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="xianshi == '购买单位经办人身份证' ? innerVisible : false"
      center
      :show-close="false"
      custom-class="zhengjia6"
    >
      <el-form ref="form" :model="gmFjmes" :rules="rules">
        <el-form-item label-width="91px" label="经办人:" prop="gmdwjbrXm">
          <el-select
            v-model="gmFjmes.gmdwjbrXm"
            :disabled="type"
            placeholder="请输入经办人姓名"
            clearable
            @change="jbrChange"
          >
            <el-option
              v-for="item in jbrList"
              :key="item.id"
              :label="item.xm"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label-width="91px" label="身份证:" prop="gmdwjbrjbrSfzh">
          <el-input
            v-model="gmFjmes.gmdwjbrjbrSfzh"
            placeholder="请输入证件编号"
            :disabled="type"
          />
        </el-form-item>
        <el-form-item label-width="91px" label="手机号码:" prop="gmdwjbrjbrSjh">
          <el-input
            v-model="gmFjmes.gmdwjbrjbrSjh"
            :disabled="type"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item
          style="width: 100%"
          prop="images"
          :rules="{
            required: true,
            validator: fileValidator,
          }"
        >
          <div class="fujian required">
            上传附件（{{ fileList.length }}/6）(500KB以内)
          </div>
          <el-upload
            ref="upload"
            :headers="token"
            :disabled="type"
            class="avatar-uploader"
            :limit="6"
            :file-list="fileList"
            list-type="picture-card"
            :action="returnSaveFile"
            :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleprogress"
            :before-upload="beforeAvatarUpload"
          >
            <i class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            append-to-body
            :visible.sync="dialogVisible"
            class="yulan"
          >
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          @click="confirm('form', 'cancel')"
        >取 消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          :disabled="type"
          @click="confirm('form', 'tj')"
        >保存</el-button>
      </div>
    </el-dialog>
    <!-- 获取单位信息 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="xianshi"
      :visible="xianshi == '单位' ? innerVisible : false"
      center
      @close="confirm1"
    >
      <div>
        <el-table
          ref="dialogdw"
          :data="tableData"
          style="width: 100%"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" align="center" :max="1" :min="1" />
          <el-table-column label="单位名称" align="center">
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.dwmc }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位地址" align="center">
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.dwdz }}</span>
            </template>
          </el-table-column>
          <el-table-column label="法人/经营者名称" align="center">
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.frmc }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位座机" align="center">
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.dwzj }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center">
            <template slot-scope="scope">
              <span size="medium">{{ scope.row.cjsj }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          @click="confirm1"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import {
  url1,
  getToken,
  returnSaveFile,
  returnShowPic,
  selectgmzDwMes,
  jbrMes,
  gethxpJl,
  getkv
} from '@/assets/js/common.js'
import { deleteJKHCImage } from '@/assets/js/jkhc.js'
export default {
  props: {
    innerVisible: {
      type: Boolean
    },
    xianshi: {
      type: String
    },
    type: {
      type: Boolean
    },
    insidehxp: {
      type: Object
    }
  },
  data() {
    const dwxg = (rule, value, callback) => {
      if (!this.gmFjmes.yyzzZczb) {
        callback(new Error('请输入'))
      } else if (this.gmFjmes.yyzzZczb && this.gmFjmes.yyzzZczb.length > 100) {
        callback(new Error('输入字符为1到100之间！'))
      } else if (!this.gmFjmes.yyzzZczbdw) {
        callback(new Error('请选择单位'))
      } else if (
        this.gmFjmes.yyzzZczbdw &&
        this.gmFjmes.yyzzZczb.yyzzZczbdw > 20
      ) {
        callback(new Error('输入字符为1到20之间！'))
      } else {
        callback()
      }
      callback()
    }
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time > Date.now()
        }
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '永久日期',
            onClick(picker) {
              const date = new Date('2099-12-31')
              picker.$emit('pick', date)
            }
          }
        ]
      },
      options: [], // 化学品级联数据
      token: {
        Authorization: getToken()
      },
      URL1: '',
      returnSaveFile: '', // 返回保存图片路径
      returnShowPic: '', // 返回回显图片路径
      multipleSelection: [], // 多选选中数据
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0,
      tableData: [],
      dialogImageUrl: '', // uploaded组件自带
      dialogVisible: false, // uploaded组件自带
      fileList: [], // uploaded组件自带
      yzd_zjzj: [], // 单位信息
      gmFjmes: {}, // 附件list
      rules: {
        hfsyDwmc: [{ required: true, message: '请输入', trigger: 'blur' }],
        hfsySl: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 255),
            trigger: 'blur'
          }
        ],
        hfsySldw: [{ required: true, message: '请输入', trigger: 'blur' }],
        zylx: [{ required: true, message: '请输入', trigger: 'blur' }],
        hfsyQdrq: [{ required: true, message: '请输入', trigger: 'blur' }],
        yyzzMc: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: 'blur'
          }
        ],
        yyzzJyfw: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 3000),
            trigger: 'blur'
          }
        ],
        yyzzTyshxydm: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 100),
            trigger: 'blur'
          }
        ],
        yxqKs: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'blur'
          }
        ],
        yxqJs: [{ required: true, message: '请选择时间', trigger: 'blur' }],
        fzjg: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 255),
            trigger: 'blur'
          }
        ],
        fzrq: [{ required: true, message: '请选择发证日期', trigger: 'blur' }],
        yyzzLx: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 30),
            trigger: 'blur'
          }
        ],
        hfsyHxpmc: [{ required: true, message: '请输入', trigger: 'blur' }],
        yyzzFr: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: 'blur'
          }
        ],
        yyzzZczbxg: [
          { required: true, validator: dwxg, trigger: ['blur', 'change'] }
        ],
        yyzzClrq: [{ required: true, message: '请输入', trigger: 'blur' }],
        qtzzZsmc: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: 'blur'
          }
        ],
        qtzzZsbh: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 100),
            trigger: 'blur'
          }
        ],
        qtzzZjnr: [{ required: true, message: '请输入', trigger: 'blur' }],
        gxhtHxp: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 500),
            trigger: 'blur'
          }
        ],
        gxhtHtbh: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 100),
            trigger: 'blur'
          }
        ],
        gxhtJfm: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: 'blur'
          }
        ],
        gxhtYfm: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: 'blur'
          }
        ],
        gxhtQdrq: [{ required: true, message: '请选择', trigger: 'blur' }],
        qtzjZsmc: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: 'blur'
          }
        ],
        qtzjZsbh: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 100),
            trigger: 'blur'
          }
        ],
        qtzjZjnr: [{ required: true, message: '请输入', trigger: 'blur' }],
        gmdwjbrXm: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 200),
            trigger: ['blur', 'change']
          }
        ],
        gmdwjbrjbrSjh: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 50),
            trigger: ['blur', 'change']
          }
        ],
        gmdwjbrjbrSfzh: [
          {
            required: true,
            validator: (rule, value, callback) =>
              lengthValidate(rule, value, callback, 'bt', 100),
            trigger: ['blur', 'change']
          }
        ]
      },
      zjlx: '',
      jbrList: [],
      dwlxList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    this.selectgmzDwMess({
      page: this.currentPage,
      size: this.pagesize
    })
    jbrMes().then((e) => {
      this.jbrList = e.data.data
    })
    // 单位
    getkv('yzd_xkzdjdw').then((e) => {
      this.yzd_zjzj = e.data.data
    })
    // 获取单位类型
    getkv('yzd_dwlx').then((e) => {
      this.dwlxList = e.data.data
    })
    // 获取化学品级联数据
    gethxpJl().then((e) => {
      this.options = e.data.data
    })
  },
  beforeDestroy() { },
  methods: {
    fileValidator(rule, value, callback) {
      // 附件校验
      if (!this.fileList || this.fileList.length === 0) {
        callback(new Error('附件必传!'))
      } else {
        if (this.fileList.some(d => d.status === 'uploading')) {
          callback(new Error('附件未上传完成，请稍后!'))
          return
        }
        callback()
      }
    },
    lengthValidate,
    // 化学品级联改变
    handleChange(value) {
      if (value == undefined) return
      if (this.xianshi == '合法使用需要证明') {
        this.gmFjmes.hfsyHxpmc =
          this.$refs.hxps.getCheckedNodes()[0].data.label
      }
    },
    // 经办人
    jbrChange(val) {
      this.jbrList.some((item) => {
        if (item.id == val) {
          this.gmFjmes.gmdwjbrXm = val
          this.gmFjmes.gmdwjbrjbrSfzh = item.zjhm
          this.gmFjmes.gmdwjbrjbrSjh = item.sjhm
        }
      })
    },
    // 初始化页面
    cshYm(mes, zjlx) {
      this.$nextTick(() => {
        if (this.type) {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'none'
        } else {
          document.getElementsByClassName(
            'el-upload--picture-card'
          )[0].style.display = 'inline-block'
        }
        // this.$refs["form"].clearValidate();
        // this.$refs.form.resetFields();
        this.zjlx = zjlx
        // this.fileList = [];

        if (mes == undefined) {
        } else {
          if (mes.fjList) {
            mes.fjList.forEach((item) => {
              item.id != undefined
                ? this.fileList.push({
                  url: this.returnShowPic + item.wjdz,
                  id: item.id
                })
                : this.fileList.push({
                  url: this.returnShowPic + item.wjdz
                })
            })
          } else {
            mes.fjList = []
          }

          this.jbrChange(mes.gmdwjbrXm)
          this.gmFjmes = JSON.parse(JSON.stringify(mes))
        }
        // console.log(this.gmFjmes);

        if (zjlx == '6') this.gmFjmes.gxhtHxp = this.insidehxp.hxpBm
        // if (zjlx == "3") {
        //   this.gmFjmes.hfsyDwmc = this.insidehxp.hfsyDwmc;
        //   this.gmFjmes.hfsyHxpmc = this.insidehxp.hxpMc;
        // }
      })
    },
    // 成功
    handleAvatarSuccess(res, file, fileList) {
      if (file.status == 'success' && this.gmFjmes.fjList) {
        this.gmFjmes.fjList.push({
          wjdz: res.data.url,
          zjlx: this.zjlx
        })
        this.fileList = fileList
      }
    },
    // 文件列表移除文件时
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.length = this.fileList.length

      if (file.id) {
        // 删除数据库图片
        deleteJKHCImage(file.id).then((e) => { })
        // 删除初始化list中的图片
        this.gmFjmes.fjList.filter((item, index) => {
          if (item.id == file.id) {
            this.gmFjmes.fjList.splice(index, 1)
          }
          return this.gmFjmes.fjList
        })
      } else {
        // 未上传的图片删除
        // 回显
        if (file.url.includes(this.returnShowPic)) {
          this.gmFjmes.fjList.filter((item, index) => {
            if (item.wjdz == file.url.split('=')[1]) { this.gmFjmes.fjList.splice(index, 1) }
            return
          })
        }
        // 新上传未回显
        else if (file.response) {
          this.gmFjmes.fjList.filter((item, index) => {
            if (item.wjdz == file.response.data.url) { this.gmFjmes.fjList.splice(index, 1) }
            return
          })
        }
      }
    },

    // 证书关闭弹窗
    confirm(formName, leixing) {
      // 如果是查看不可编辑，不需要验证
      if (this.type == true || leixing == 'cancel') {
        this.$emit('dialog-inside')
        this.$refs[formName].resetFields()
        this.$refs['form'].clearValidate()
        this.fileList = []
        this.gmFjmes = {}
        return
      } else {
        this.$refs[formName].validate((valid, obj) => {
          if (valid && this.fileList.length > 0) {
            var imageList = this.gmFjmes.fjList

            this.gmFjmes = {
              id: this.gmFjmes.id,
              zjlx: this.zjlx,
              yxqKs: this.gmFjmes.yxqKs,
              yxqJs: this.gmFjmes.yxqJs,
              fzrq: this.gmFjmes.fzrq, // 发证日期
              fzjg: this.gmFjmes.fzjg, // 发证机关
              hfsyDwmc: this.gmFjmes.hfsyDwmc, // 合法使用单位名称
              hfsyHxpmc: this.gmFjmes.hfsyHxpmc, // 合法使用化学品名
              hfsySl: this.gmFjmes.hfsySl, // 合法使用数量
              hfsySldw: this.gmFjmes.hfsySldw, // 合法使用数量单位
              hfsyQdrq: this.gmFjmes.hfsyQdrq, // 合法使用签订日期
              yyzzMc: this.gmFjmes.yyzzMc, // 营业执照名称
              yyzzJyfw: this.gmFjmes.yyzzJyfw, // 营业执照经营范围
              yyzzTyshxydm: this.gmFjmes.yyzzTyshxydm, // 营业执照社会统一信息代码
              yyzzLx: this.gmFjmes.yyzzLx, // 类型
              yyzzFr: this.gmFjmes.yyzzFr, // 法人/经营者
              yyzzZczb: this.gmFjmes.yyzzZczb, // 营业执照注册资本
              yyzzZczbdw: this.gmFjmes.yyzzZczbdw, // 营业执照注册资本单位
              yyzzZczbdwmc: this.gmFjmes.yyzzZczbdwmc,
              yyzzClrq: this.gmFjmes.yyzzClrq, // 营业执照创立日期
              qtzzZsmc: this.gmFjmes.qtzzZsmc, // 其他组织名称
              qtzzZsbh: this.gmFjmes.qtzzZsbh, // 其他住址编码
              qtzzZjnr: this.gmFjmes.qtzzZjnr, // 其他组织内容
              gxhtHxp: this.gmFjmes.gxhtHxp, // 购销合同化学品
              gxhtHtbh: this.gmFjmes.gxhtHtbh,
              gxhtJfm: this.gmFjmes.gxhtJfm,
              gxhtYfm: this.gmFjmes.gxhtYfm,
              gxhtQdrq: this.gmFjmes.gxhtQdrq,
              qtzjZsmc: this.gmFjmes.qtzjZsmc, // 其他证件名称
              qtzjZsbh: this.gmFjmes.qtzjZsbh, // 其他证件证书编号
              qtzjZjnr: this.gmFjmes.qtzjZjnr, // 其他证件内容
              gmdwjbrXm: this.gmFjmes.gmdwjbrXm, // 购买单位经办人姓名
              gmdwjbrjbrSjh: this.gmFjmes.gmdwjbrjbrSjh, // 购买单位经办人手机号
              gmdwjbrjbrSfzh: this.gmFjmes.gmdwjbrjbrSfzh, // 购买单位经办人身份证号
              fjList: imageList
            }
            this.$emit('dialog-inside', this.gmFjmes)
            this.$refs[formName].resetFields()
            this.$refs['form'].clearValidate()
            this.fileList = []
            this.gmFjmes = {}
          } else {
            this.fileList.length > 0
              ? ''
              : this.$message({
                type: 'info',
                message: '请上传图片'
              })
            return false
          }
        })
      }
    },

    // 往来单位确认时关闭弹窗并将选中单位id传到父组件
    confirm1() {
      this.$emit(
        'dialog-inside1',
        this.multipleSelection.length > 0 ? this.multipleSelection[0].id : ''
      )
      this.multipleSelection = [] // 关闭时清空选择数据
      this.$refs.dialogdw.clearSelection() // 关闭时清空选择框
    },
    // 文件超出个数限制时
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      )
    },
    beforeAvatarUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)
      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 文件改变时
    handleprogress(file, fileList) {
      this.fileList = fileList
      this.length = this.fileList.length
    },
    // 点击文件列表中已上传的文件，预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    // 多选框只能选择一行
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.dialogdw.clearSelection()
        this.$refs.dialogdw.toggleRowSelection(val.pop())
      }
    },
    // 获取购买证往来单位信息
    selectgmzDwMess(dataObj) {
      selectgmzDwMes(dataObj).then((e) => {
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.selectgmzDwMess({
        page: this.currentPage,
        size: this.pagesize
      })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.selectgmzDwMess({
        page: this.currentPage,
        size: this.pagesize
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.avatar-uploader .el-upload {
  border: 0 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader {
  height: 96px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 96px !important;
  height: 96px !important;
  line-height: 96px !important;
  text-align: center;
  background: #f3f3f3;
  border-radius: 3px;
}
/deep/.el-upload {
  line-height: 96px !important;
}
.avatar {
  display: block;
}
/deep/.el-upload-list--picture-card .el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 96px !important;
  height: 96px !important;
}

/deep/.el-upload-list__item {
  transition: none !important;
}
/deep/.zhengjia1,
/deep/.zhengjia2,
/deep/.zhengjia3,
/deep/.zhengjia4,
/deep/.zhengjia5,
/deep/.zhengjia6 {
  border-radius: 5px;
  width: 1136px;
  margin-top: 5vh !important;
  .el-dialog__title {
    display: block;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
    margin: 30px auto 42px;
  }
  .el-dialog__body {
    padding: 0 114px !important;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      .el-textarea__inner {
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .el-form-item {
        margin-bottom: 20px;
        .el-input {
          width: 340px;
          height: 39px;
        }
        .el-form-item__label {
          padding-right: 6px;
        }
        & > :last-child {
          margin-left: 21px;
        }
      }
    }
  }
  .el-dialog__footer {
    padding: 10px 20px 83px;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 174px !important;
  }
}
/deep/.zhengjia1 {
  .el-form-item {
    &:nth-child(4) {
      // width: 47.5%;
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 340px !important;
      }
    }
  }
}
/deep/.zhengjia2 {
  .el-form-item {
    &:nth-child(4),
    &:nth-child(8) {
      width: 47.5%;
    }
    &:nth-child(5) {
      .el-form-item__content {
        & > .el-input {
          width: 241px;
          margin-right: 10px;
        }
        .el-select {
          width: 90px;
          .el-input {
            width: 90px;
          }
        }
      }
    }
    &:nth-child(7) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }
    &:nth-child(9) {
      width: 100%;
      .el-input {
        width: 100% !important;
      }
    }
    &:nth-child(10) {
      width: 100%;
    }
  }
}
/deep/.zhengjia3 {
  .el-form-item {
    //有效期
    &:nth-child(3) {
      width: 52% !important;
      height: 39px;
      [class*="el-col-11.5"] {
        width: 174px !important;
        .el-form-item__content {
          margin: 0 !important;
        }
      }
    }

    &:nth-child(5) {
      width: 100%;
    }

    &:nth-child(7) {
      width: 100%;
    }
  }
}
/deep/.zhengjia4 {
  .el-form-item {
    &:nth-child(5) {
      width: 100%;
    }
  }
}
/deep/.zhengjia6 {
  .el-form-item {
    &:nth-child(3) {
      width: 100%;
    }
  }
}
/deep/ .el-dialog {
  margin-top: 5vh !important;
  .el-dialog__body {
  }
  .el-dialog__footer {
    padding: 70px 0 47px;
    .el-button {
      width: 148px;
      height: 60px;
      margin: 0 45px;
    }
  }
}
/deep/.el-button--primary {
  background: #4170ff !important;
}
</style>
